import React from 'react';
import { cn } from '@/lib/utils';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useApp } from '@/context/AppContext';

export const DashboardLayout = ({ children, title, fullWidth = false }) => {
  const { sidebarCollapsed } = useApp();

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <TopBar title={title} />
      
      <main 
        className={cn(
          "pt-16 min-h-screen transition-all duration-300",
          sidebarCollapsed ? "pl-[70px]" : "pl-[260px]"
        )}
      >
        <div className={cn(
          "h-[calc(100vh-64px)]",
          !fullWidth && "p-6"
        )}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
